// src/components/AssetForm.js

import React, { useState } from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  Stack,
  Box,
} from "@mui/material";
import WebcamCapture from "./WebcamCapture";

// ตัวอย่างรายการ "สถานที่เก็บ"
const locationOptions = [
  "พนักงานดูแลของตนเอง",
  "No. 62 ฝั่งบ้าน",
  "No. 62 ชั้น 1",
  "No. 62 ชั้น 2",
  "No. 62 ชั้น 3",
  "No. 62 ชั้น 6",
  "No. 64 ชั้น 1",
  "No. 64 ชั้น 2",
  "No. 64 ชั้น 3",
  "No. 64 ชั้น 4",
  "No. 64 ชั้น 5",
  "No.62 ห้องประชุมชั้น 1 ห้องดาวเรือง",
  "No.62 ห้องประชุมชั้น 2 ห้องแตงโม",
  "No.62 ห้องประชุมชั้น 3 ห้องมะรุม",
  "No.64 ห้องประชุมชั้น 3 ห้องมะรุม",
  "No.51",
];

// ตัวอย่างรายการชื่อผู้รับผิดชอบ
const approverOptions = [
  "อาทิตย์ สีตาไว (พี่โจ)",
  "ชุติมา สุขสมัย (พี่แอน)",
  "จันทร์วิรา ตั้งศิวาลัย (พี่ต่าย)",
  "วรเวช กิติราช (หนุ่ม)",
  "ชินาลัย หนูปลอด (แป้ว)",
  "พัณณ์ชิตา ธีรโรจพรชัยกุล (ศา)",
  "พงษ์พิพัฒน์ พรพันธ์เดชวิทยา (โอม)",
  "ภาวิกา สีตาไว (น้อย)",
  "ธีรศานต์ อ่วมเกิด (โดม)",
  "เชาวนัส พันธุ์สว่าง (แคมป์)",
  "พวงพัตรา พุฒพลายงาม (หมวย)",
  "กุลทรี ขาวสว่าง (จอย)",
  "อภิชาติ หาญเมืองใจ (ลุ้ย)",
  "ชณากร น้อยนคร (กร)",
  "นรพงษ์ ชมภูพงษ์ (น็อต)",
  "เตชทัต อชิรวุฒิเดชา (โตน)",
  "จินตนา ศรีอำไพ (พี่นา)",
  "อาณัติ พุทธา (โต้ง)",
  "อมรา ทองปน (อัม)",
  "วรวิทย์ ชิตรัตน์ (วิทย์)",
  "เครือวัลย์ ศรีอำไพ (วัลย์)",
  "ภัสสราณัฐ รวยธนาสมบัติ (นัท)",
  "ดวงสุดา โปหลง (ฟ้า)",
  "วิไลวรรณ หาญเมืองใจ (น้อง)",
  "ธนัชพร โล่ห์สุวรรณ (แนน)",
  "ขมนรรถ เทียมทอง (ไผ่)",
  "เอกรินทร์ ห่วงปรากฎ (ตาล)",
  "วิทยา วงศ์ปิยะรัตนกุล (เบียร์)",
  "ฉัตรธิดา จิตโสภาพันธุ์ (ฟิวเจอร์)",
  "ธีรติการ ตรีรัตน์ (แบงค์)",
  "กัญญาภัทร เนื้อนวล (เบสท์)",
  "ภาชณาภรณ์ เป็นแรง (แพรว)",
  "อริญา บรรพันธุ์ (เฌอ)",
  "จิรโชติ พรพันธ์เดชวิทยา (อั๋น)",
  "นภัสสรณ์ วันสว่างเมือง (ทราย)",
  "มธุรส นาใจคง (จ๋า)",
  "อมลวรรณ อาชาสวัสดิ์ (ผักกาด)",
  "สามารถ สีตาไว (หนึ่ง)",
  "ลัดดา วิเวกวรรณ์ (ลัดดา)",
  "สริตา เกศมณี (บีม)",
  "สุดารัตน์ เจริญชัยชนะ (บิวตี้)",
  "กิตติคุณ เพ็ชรแจ้ง (ป๊อบ)",
  "อิสรินทร์ แสนคำ (ไอซ์)",
  "ศรณ์นพัต เหลืองมณีเวช (แพรวแพรว)",
  "กรกนก ศิริโวหาร (เฟิร์น)",
  "ณัฐณิชา ไม้ชุน (ป๊อบคอร์น)",
  "ณัฐพล อนันต์ศิริขจร (หมู)",
  "ยุทธวัฒน์ ต่อพันธ์ (เบ็นซ์)",
  "นริศรา ไทยหวล (อีฟ)",
  "นันทวรรณ อินทรจันทร์ (ลูกตาล)",
  "หทัยชนก สมิทธ์ศราการย์ (ลูกแพร)",
  "รัญชนา ชยาภิรมย์ (อุ้ม)",
  "อินทพร อรุณวิศวกุล (อิน)",
  "รษิกา บำเรอจิต (ส้มจุก)",
  "ลฎาภา แก้วเพชร (ทรายทราย)",
  "ธนาพัทธ์ วิริยะยนตรศิลป์ (เบน)",
  "ปิยะนันท์ จอมอุ่น (โดนัท)",
  "พัชราภรณ์ สระทองที (เฟิร์น)",
  // ... (ตามที่คุณกำหนดเอง) ...
];

// ตัวอย่างรายการ "Brand"
const brandOptions = [
  "ACER",
  "APPLE",
  "ASUS",
  "DELL",
  "HP",
  "LG",
  "LENOVO",
  "MICORSOFT SURFACE",
  "NIKON",
  "OPPO",
  "SAMSUNG",
  "SHARP",
  "SONY",
  "VNJO Q",
  "อื่น ๆ",
];

// ตัวอย่างรายการ "ชื่อทรัพย์สิน"
const assetNameOptions = [
  "LAPTOP",
  "DESKTOP - UPC",
  "DESKTOP - MONITOR",
  "DESKTOP ALL IN ONE",
  "MONITOR",
  "UPS",
  "IPAD/TAPLET",
  "โทรศัพท์มือถือ",
  "โทรศัพท์ไร้สาย",
  "กล้องถ่ายภาพ",
  "กล้องวีดีโอ",
  "เลนส์",
  "อื่น ๆ",
];

function AssetForm() {
  // เรียงลำดับฟิลด์ตรงกับ Apps Script (ดู doPost ด้านล่าง)
  const [formData, setFormData] = useState({
    usageType: "", // B
    location: "", // C
    approver: "", // D
    assetName: "", // E
    assetCategory: "", // F
    brand: "", // G
    modelType: "", // H
    serialNumber: "", // I
    assetId: "", // J
    barcode: "", // K
    receiveDate: "", // L
    assetStatus: "", // M
    imageBase64: "", // -> N (Direct Link)
    otherDetail: "", // O
    remark: "", // P
  });

  const [showWebcam, setShowWebcam] = useState(false);

  // handleChange สำหรับ field ทั่วไป
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // เมื่อเลือกไฟล์รูป -> แปลง base64
  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((prev) => ({ ...prev, imageBase64: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  // ถ่ายรูปผ่าน Webcam
  const handleCapture = (imageSrc) => {
    setFormData((prev) => ({ ...prev, imageBase64: imageSrc }));
    setShowWebcam(false);
  };
  const handleCancelWebcam = () => setShowWebcam(false);

  // ส่งข้อมูลไป Apps Script
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // URL Web App (จากการ Deploy)
      //const scriptURL = "http://localhost:3001/submit"; // <-- ใส่ของคุณ
      const scriptURL = "https://s4.julaherb.co/post/submit"; // <-- url production

      const response = await fetch(scriptURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const text = await response.text();

      if (response.ok && text === "SUCCESS") {
        alert("บันทึกข้อมูลเรียบร้อย!");

        // รีเซ็ตฟอร์ม
        setFormData({
          usageType: "",
          location: "",
          approver: "",
          assetName: "",
          assetCategory: "",
          brand: "",
          modelType: "",
          serialNumber: "",
          assetId: "",
          barcode: "",
          receiveDate: "",
          assetStatus: "",
          imageBase64: "",
          otherDetail: "",
          remark: "",
        });
      } else {
        alert("เกิดข้อผิดพลาดในการบันทึก: " + text);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("เชื่อมต่อไม่ได้");
    }
  };

  return (
    <Container maxWidth='md' sx={{ mt: 4 }}>
      <Card>
        <CardContent>
          {/* โลโก้บริษัท */}
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <img
              src='/company_logo.png'
              alt='Company Logo'
              style={{ maxHeight: "90px" }}
            />
          </Box>

          <Typography variant='h5' gutterBottom>
            ฟอร์มบันทึกทรัพย์สิน บริษัท เจแอลซี กรุ๊ป จำกัด
          </Typography>

          <Box component='form' onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              {/* ประเภทการใช้งาน (B) */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>ประเภทการใช้งาน</InputLabel>
                  <Select
                    name='usageType'
                    value={formData.usageType}
                    label='ประเภทการใช้งาน'
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value=''>-- เลือกประเภท --</MenuItem>
                    <MenuItem value='ใช้ทำงาน'>ใช้ทำงาน</MenuItem>
                    <MenuItem value='ส่วนกลาง(บริษัท)'>
                      ส่วนกลาง(บริษัท)
                    </MenuItem>
                    <MenuItem value='Stock'>Stock</MenuItem>
                    <MenuItem value='งานแผนก ACCOUNTING'>
                      งานแผนก ACCOUNTING
                    </MenuItem>
                    <MenuItem value='งานแผนก HR'>งานแผนก HR</MenuItem>
                    <MenuItem value='งานแผนก PURCHASING'>
                      งานแผนก PURCHASING
                    </MenuItem>
                    <MenuItem value='งานแผนก DATA'>งานแผนก DATA</MenuItem>
                    <MenuItem value='งานแผนก BRANDING'>
                      งานแผนก BRANDING
                    </MenuItem>
                    <MenuItem value='งานแผนก MKT COMMU'>
                      งานแผนก MKT COMMU
                    </MenuItem>
                    <MenuItem value='งานแผนก OFFLINE TRADE'>
                      งานแผนก OFFLINE TRADE
                    </MenuItem>
                    <MenuItem value='งานแผนก E-COM'>งานแผนก E-COM</MenuItem>
                    <MenuItem value='งานแผนก ONLINE PACKING'>
                      งานแผนก ONLINE PACKING
                    </MenuItem>
                    <MenuItem value='งานแผนก ADMIN SALE'>
                      งานแผนก ADMIN SALE
                    </MenuItem>
                    <MenuItem value='งานแม่บ้าน'>งานแม่บ้าน</MenuItem>
                    <MenuItem value='งานคนขับรถ'>งานคนขับรถ</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* สถานที่เก็บ (C) */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>สถานที่เก็บ</InputLabel>
                  <Select
                    name='location'
                    value={formData.location}
                    label='สถานที่เก็บ'
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value=''>-- เลือกสถานที่ --</MenuItem>
                    {locationOptions.map((loc) => (
                      <MenuItem key={loc} value={loc}>
                        {loc}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* ชื่อผู้รับผิดชอบ (D) */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>ชื่อผู้รับผิดชอบ</InputLabel>
                  <Select
                    name='approver'
                    value={formData.approver}
                    label='ชื่อผู้รับผิดชอบ'
                    onChange={handleChange}
                  >
                    <MenuItem value=''>-- เลือกผู้รับผิดชอบ --</MenuItem>
                    {approverOptions.map((apv) => (
                      <MenuItem key={apv} value={apv}>
                        {apv}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* ชื่อทรัพย์สิน (E) */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>ชื่อทรัพย์สิน</InputLabel>
                  <Select
                    name='assetName'
                    value={formData.assetName}
                    label='ชื่อทรัพย์สิน'
                    onChange={handleChange}
                  >
                    <MenuItem value=''>-- เลือกชื่อทรัพย์สิน --</MenuItem>
                    {assetNameOptions.map((an) => (
                      <MenuItem key={an} value={an}>
                        {an}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* ประเภททรัพย์สิน (F) */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>ประเภททรัพย์สิน</InputLabel>
                  <Select
                    name='assetCategory'
                    value={formData.assetCategory}
                    label='ประเภททรัพย์สิน'
                    onChange={handleChange}
                  >
                    <MenuItem value=''>-- เลือกประเภท --</MenuItem>
                    <MenuItem value='PC'>PC</MenuItem>
                    <MenuItem value='Notebook'>Notebook</MenuItem>
                    <MenuItem value='Drone'>Drone</MenuItem>
                    <MenuItem value='กล้องถ่ายรูป'>กล้องถ่ายรูป</MenuItem>
                    <MenuItem value='Computer'>Computer</MenuItem>
                    <MenuItem value='เครื่องเสียง'>เครื่องเสียง</MenuItem>
                    <MenuItem value='โทรศัพท์'>โทรศัพท์</MenuItem>
                    <MenuItem value='โทรทัศน์'>โทรทัศน์</MenuItem>
                    <MenuItem value='อุปกรณ์ไลฟ์'>อุปกรณ์ไลฟ์</MenuItem>
                    <MenuItem value='อื่นๆ'>อื่นๆ</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Brand (G) */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>Brand</InputLabel>
                  <Select
                    name='brand'
                    value={formData.brand}
                    label='Brand'
                    onChange={handleChange}
                  >
                    <MenuItem value=''>-- เลือก Brand --</MenuItem>
                    {brandOptions.map((b) => (
                      <MenuItem key={b} value={b}>
                        {b}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Model/Type (H) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label='Model/Type'
                  name='modelType'
                  value={formData.modelType}
                  onChange={handleChange}
                />
              </Grid>

              {/* S/N Number (I) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label='S/N Number'
                  name='serialNumber'
                  value={formData.serialNumber}
                  onChange={handleChange}
                />
              </Grid>

              {/* Asset ID (J) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label='Asset ID'
                  name='assetId'
                  value={formData.assetId}
                  onChange={handleChange}
                />
              </Grid>

              {/* Barcode (K) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label='Barcode'
                  name='barcode'
                  value={formData.barcode}
                  onChange={handleChange}
                />
              </Grid>

              {/* วันที่รับทรัพย์สิน (L) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label='วันที่รับทรัพย์สิน'
                  type='date'
                  name='receiveDate'
                  value={formData.receiveDate}
                  onChange={handleChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {/* สถานะทรัพย์สิน (M) */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel>สถานะทรัพย์สิน</InputLabel>
                  <Select
                    name='assetStatus'
                    value={formData.assetStatus}
                    label='สถานะทรัพย์สิน'
                    onChange={handleChange}
                  >
                    <MenuItem value=''>-- เลือกสถานะ --</MenuItem>
                    <MenuItem value='พร้อมใช้งาน'>พร้อมใช้งาน</MenuItem>
                    <MenuItem value='ส่งซ่อม'>ส่งซ่อม</MenuItem>
                    <MenuItem value='เลิกใช้งาน'>เลิกใช้งาน</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* ข้อมูลอื่นๆ (O) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  multiline
                  label='ข้อมูลอื่นๆ'
                  name='otherDetail'
                  value={formData.otherDetail}
                  onChange={handleChange}
                  placeholder='ระบุข้อมูลเพิ่มเติม หากมี...'
                />
              </Grid>

              {/* หมายเหตุ (P) */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label='หมายเหตุ'
                  name='remark'
                  value={formData.remark}
                  onChange={handleChange}
                  placeholder='ระบุหมายเหตุเพิ่มเติม'
                />
              </Grid>

              {/* อัปโหลดรูป (imageBase64 -> N) */}
              <Grid item xs={12} sm={6}>
                <Stack direction='row' spacing={2} alignItems='center'>
                  <Button variant='outlined' component='label'>
                    เลือกรูป
                    <input
                      type='file'
                      accept='image/*'
                      hidden
                      onChange={handleImageChange}
                    />
                  </Button>
                  {formData.imageBase64 ? (
                    <Typography color='success.main'>
                      อัปโหลด / ถ่ายรูปแล้ว
                    </Typography>
                  ) : (
                    <Typography color='text.secondary'>
                      ยังไม่ได้เลือกรูป
                    </Typography>
                  )}
                </Stack>
              </Grid>

              {/* ปุ่ม เปิดกล้อง */}
              <Grid item xs={12} sm={6}>
                <Button variant='outlined' onClick={() => setShowWebcam(true)}>
                  เปิดกล้อง
                </Button>
                {formData.imageBase64 && (
                  <Typography color='success.main' sx={{ ml: 2 }}>
                    ถ่าย/เลือกรูปแล้ว
                  </Typography>
                )}
              </Grid>

              {/* ปุ่ม Submit */}
              <Grid item xs={12}>
                <Button variant='contained' type='submit'>
                  บันทึกข้อมูล
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      {/* พรีวิวรูป (ถ้ามี) */}
      {formData.imageBase64 && (
        <Card sx={{ mt: 2 }}>
          <CardContent sx={{ textAlign: "center" }}>
            <Typography variant='subtitle1'>พรีวิวรูปภาพ</Typography>
            <img
              src={formData.imageBase64}
              alt='Preview'
              style={{ maxWidth: 200, marginTop: 8 }}
            />
          </CardContent>
        </Card>
      )}

      {/* Overlay กล้อง */}
      {showWebcam && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <Box sx={{ bgcolor: "#fff", p: 2, borderRadius: 1 }}>
            <WebcamCapture
              onCapture={handleCapture}
              onCancel={handleCancelWebcam}
            />
          </Box>
        </Box>
      )}
    </Container>
  );
}

export default AssetForm;
